import { gql } from '@apollo/client';
import { apolloClient } from '../config/apollo-client';

// GraphQL mutation for exiting a game
export const EXIT_GAME_MUTATION = gql`
  mutation ExitGame($input: ExitGameInput!) {
    exitGame(input: $input) {
      success
      userBalance
    }
  }
`;

// Types for the input
export interface ExitGameInput {
  sessionToken: string;
}

// Types for the response
export interface ExitGameResponse {
  success: boolean;
  userBalance: number;
}

// Raw GraphQL response interface
export interface RawExitGameResponse {
  exitGame: ExitGameResponse;
}

// ExitGame service class
export class ExitGameService {
  private static instance: ExitGameService;

  private constructor() {}

  public static getInstance(): ExitGameService {
    if (!ExitGameService.instance) {
      ExitGameService.instance = new ExitGameService();
    }
    return ExitGameService.instance;
  }

  // Exit a game with the provided session token
  async exitGame(input: ExitGameInput): Promise<ExitGameResponse> {
    try {
      const { data } = await apolloClient.mutate<RawExitGameResponse>({
        mutation: EXIT_GAME_MUTATION,
        variables: {
          input,
        },
      });

      if (!data?.exitGame) {
        throw new Error('No data received from exitGame mutation');
      }

      return data.exitGame;
    } catch (error: any) {
      console.error('Error exiting game:', error);
      if (error.graphQLErrors) {
        error.graphQLErrors.forEach((err: any) => {
          console.error('GraphQL Error:', err.message);
          console.error('Locations:', err.locations);
          console.error('Path:', err.path);
        });
      }
      if (error.networkError) {
        console.error('Network Error:', error.networkError);
      }
      throw error;
    }
  }
}

// Export singleton instance
export const exitGameService = ExitGameService.getInstance();

// Export convenience function
export async function exitGame(
  input: ExitGameInput,
): Promise<ExitGameResponse> {
  return exitGameService.exitGame(input);
}
